"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var ReactDOM = __importStar(require("react-dom"));
var redux_debounced_1 = __importDefault(require("redux-debounced"));
var connected_react_router_1 = require("connected-react-router");
var redux_1 = require("redux");
var react_redux_1 = require("react-redux");
var redux_thunk_1 = __importDefault(require("redux-thunk"));
var ElstrCore_1 = __importDefault(require("./ElstrCore"));
var ElstrUser_1 = __importDefault(require("./ElstrUser"));
var ElstrLanguage_1 = __importDefault(require("./ElstrLanguage"));
var ElstrConfig_1 = __importDefault(require("./ElstrConfig"));
var redux_immutable_state_invariant_1 = __importDefault(require("redux-immutable-state-invariant"));
var ElstrLocalStorage_1 = __importDefault(require("./ElstrLocalStorage"));
var BackendVersion_1 = require("./constants/BackendVersion");
var ElstrBaseApp = /** @class */ (function (_super) {
    __extends(ElstrBaseApp, _super);
    function ElstrBaseApp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rootComp = (React.createElement("div", null));
        /**
         * Render Root Layout / unmount if is already there
         * @param rootComponent
         */
        _this.renderRoot = function () {
            var app = document.getElementById("root");
            if (!app)
                return;
            ReactDOM.unmountComponentAtNode(app);
            // Next line has to be ignored in typescript due to library problems that can be only solved inside the lib
            // @ts-ignore
            var CR = React.createElement(connected_react_router_1.ConnectedRouter, { history: ElstrCore_1.default.history }, _this.rootComp);
            ReactDOM.render(React.createElement(react_redux_1.Provider, { store: ElstrCore_1.default.store }, CR), app);
        };
        _this.language = new ElstrLanguage_1.default(_this.renderRoot);
        _this.config = new ElstrConfig_1.default();
        _this.user = new ElstrUser_1.default(_this.renderRoot);
        return _this;
    }
    ElstrBaseApp.reuseState = function (newState, oldState) {
        if (newState === oldState) {
            return oldState;
        }
        if (oldState === undefined ||
            oldState === null ||
            newState === undefined ||
            newState === null) {
            return newState;
        }
        if (Array.isArray(newState)) {
            if (!Array.isArray(oldState)) {
                return newState;
            }
            if (newState.length !== oldState.length) {
                return newState;
            }
            var canReuse = true;
            for (var i = 0; i < newState.length; i++) {
                var newSubState = newState[i];
                var oldSubState = oldState[i];
                if (newSubState !== oldSubState) {
                    newSubState = ElstrBaseApp.reuseState(newSubState, oldSubState);
                    if (newSubState !== oldSubState) {
                        canReuse = false;
                    }
                    // additional check for libraries like immerjs which use Object.freeze mechanism for state changes
                    // in that case the following assignment isn't possible and will be skipped
                    if (!Object.isFrozen(newState)) {
                        newState[i] = newSubState;
                    }
                }
            }
            if (canReuse) {
                return oldState;
            }
            else {
                return newState;
            }
        }
        else if (typeof newState === "object") {
            if (typeof oldState !== "object") {
                return newState;
            }
            var canReuse = true;
            // reuse substate if possible and check if all new substates can be reused
            for (var key in newState) {
                if (newState.hasOwnProperty(key)) {
                    if (oldState.hasOwnProperty(key)) {
                        var newSubState = newState[key];
                        var oldSubState = oldState[key];
                        if (newSubState !== oldSubState) {
                            newSubState = ElstrBaseApp.reuseState(newSubState, oldSubState);
                            if (newSubState !== oldSubState) {
                                canReuse = false;
                            }
                            // additional check for libraries like immerjs which use Object.freeze mechanism for state changes
                            // in that case the following assignment isn't possible and will be skipped
                            if (!Object.isFrozen(newState)) {
                                newState[key] = newSubState;
                            }
                        }
                    }
                    else {
                        canReuse = false;
                    }
                }
            }
            if (canReuse) {
                // check that all old substates were reused
                for (var key in oldState) {
                    if (oldState.hasOwnProperty(key)) {
                        if (!newState.hasOwnProperty(key)) {
                            canReuse = false;
                            break;
                        }
                    }
                }
            }
            if (canReuse) {
                return oldState;
            }
            else {
                return newState;
            }
        }
        else {
            return newState;
        }
    };
    ElstrBaseApp.prototype.combineReducersAndReuseState = function (reducers) {
        var combine = redux_1.combineReducers(reducers);
        return function combineAndReuse(oldState, action) {
            var newState = combine(oldState, action);
            newState = ElstrBaseApp.reuseState(newState, oldState);
            return newState;
        };
    };
    /**
     * Setup Redux include React Router Reducer (Only Debug Mode)
     * @param reducers
     * @param initStore
     * @param appMiddleware
     */
    ElstrBaseApp.prototype.setupRedux = function (reducers, initStore, appMiddleware) {
        if (ElstrCore_1.default.store) {
            ElstrCore_1.default.store.replaceReducer(this.combineReducersAndReuseState(__assign(__assign({}, reducers), { router: connected_react_router_1.connectRouter(ElstrCore_1.default.history) })));
            return;
        }
        // Debounce enable debounce possiblity
        var middleware = __spreadArrays([
            redux_debounced_1.default(),
            redux_thunk_1.default,
            connected_react_router_1.routerMiddleware(ElstrCore_1.default.history)
        ], appMiddleware);
        // Redux middleware that spits an error on you when you try to mutate your state either inside a dispatch or
        // between dispatches. For development use only!
        // As said above, don't use this in production! It involves a lot of object copying and will degrade ' +
        // 'your app's performance. This is intended to be a tool to aid you in development and help you catch bugs.
        if (shouldAddReduxImmutableStateInvariant())
            middleware.push(redux_immutable_state_invariant_1.default());
        var composeEnhancers = typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
            ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
            : redux_1.compose;
        var enhancer = composeEnhancers(redux_1.applyMiddleware.apply(void 0, middleware));
        // Create Redux Store
        ElstrCore_1.default.store = redux_1.createStore(this.combineReducersAndReuseState(__assign(__assign({}, reducers), { router: connected_react_router_1.connectRouter(ElstrCore_1.default.history) })), initStore, enhancer);
    };
    /**
     * Helper function which setup the common Elstr stuff
     * @param reducers all reducers to use by the app
     * @param initState The initial Sate at the very first start of the app
     * @param rootComponent Module which is provided by Webpack (needed for HMR)
     * @param appMiddleware
     */
    ElstrBaseApp.prototype.setup = function (reducers, initState, rootComponent, appMiddleware) {
        if (appMiddleware === void 0) { appMiddleware = []; }
        this.setupRedux(Object.assign.apply(Object, __spreadArrays([{}], reducers)), initState, appMiddleware);
        if (rootComponent) {
            this.rootComp = rootComponent;
            this.renderRoot();
        }
    };
    /**
     * Helper function for detecting undesired object clones, returns a unique number for each object
     * NOTE: Don't use in production because adding objects to a map prevent the objects from being garbage collected
     * @param obj
     */
    ElstrBaseApp.getObjectId = function (obj) {
        if (obj === null || obj === undefined) {
            return -1;
        }
        var i = ElstrBaseApp.knownObjects.get(obj);
        if (i) {
            return i;
        }
        else {
            ElstrBaseApp.knownObjectCount = ElstrBaseApp.knownObjectCount + 1;
            ElstrBaseApp.knownObjects.set(obj, ElstrBaseApp.knownObjectCount);
            return ElstrBaseApp.knownObjectCount;
        }
    };
    ElstrBaseApp.ELSTR_BACKEND_VERSION = BackendVersion_1.ELSTR_BACKEND_VERSION.BE2;
    ElstrBaseApp.ELS = new ElstrLocalStorage_1.default();
    /**
     * Helper array for detecting state mutations
     */
    ElstrBaseApp.knownObjects = new Map();
    /**
     * Helper counter for detecting state mutations
     */
    ElstrBaseApp.knownObjectCount = 0;
    return ElstrBaseApp;
}(ElstrCore_1.default));
exports.default = ElstrBaseApp;
function shouldAddReduxImmutableStateInvariant() {
    if (process.env.NODE_ENV === "production") {
        return false;
    }
    if (process.env.REACT_APP_REDUX_IMMUTABLE_STATE_INVARIANT &&
        process.env.REACT_APP_REDUX_IMMUTABLE_STATE_INVARIANT === "false") {
        return false;
    }
    return true;
}
//# sourceMappingURL=ElstrBaseApp.js.map